import Ajax from '../util/ajax';
import { hastaReceiverDeleted } from '../reducers/hastaReceiversSlice';
export function deleteHastaReceiver(id, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/hasta-receiver/' + id;
        ajax.del(url, undefined, () => {
            dispatch(hastaReceiverDeleted(id));
            okCallback();
        }, () => {
            if (errorCallback != undefined) {
                errorCallback();
            }
        });
    };
}
